import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { PrimaryButton } from './PrimaryButton';
import { responseOutcomes } from '../../data/teaser';
type ReframeScreenProps = {
  answer: 'yes' | 'no' | null;
  onNext: () => void;
};
const EASE = [0.23, 1, 0.32, 1] as const;
export function ReframeScreen({
  answer,
  onNext
}: ReframeScreenProps) {
  const reduced = useReducedMotion() ?? false;
  return <div className="flex h-full flex-col" data-id="element-222" data-mp="2551ojtys3zen">
      {answer && <p className="font-mono text-[11px] tracking-[0.16em] text-graphite" data-id="element-223" data-mp="2a2lbrjdgfmiq">
          YOU SAID <span className="text-ink" data-id="element-224" data-mp="2e4gfsvmrse07">{answer.toUpperCase()}</span> · HERE’S WHY IT MATTERS
        </p>}
      <h2 className="mt-3 text-[32px] font-semibold leading-[1.04] tracking-[-0.035em] text-ink" data-id="element-225" data-mp="2iuwu0hyf03nm">
        The goal isn’t maximum stimulation.
      </h2>
      <p className="mt-3 text-[16px] leading-snug text-graphite" data-id="element-226" data-mp="1md0ia6jod6v7">
        It’s an appropriate ovarian response for the individual patient.
      </p>

      <div className="mt-8" role="img" aria-label="Continuum from too little to too much response, with appropriate response in the middle" data-id="element-227" data-mp="2n2nloxxbv898">
        <div className="relative h-10" data-id="element-228" data-mp="2i3kqe575ggeg">
          <div className="absolute inset-x-0 top-1/2 flex h-[6px] -translate-y-1/2 overflow-hidden rounded-full" data-id="element-229" data-mp="2dcchda9qex1t">
            <span className="flex-1 bg-ink/10" data-id="element-230" data-mp="28drfz7iqu7bs" />
            <span className="w-[34%] bg-accent" data-id="element-231" data-mp="28czkrxt26bm1" />
            <span className="flex-1 bg-ink/10" data-id="element-232" data-mp="23eoajlyupz3a" />
          </div>
          <motion.span className="absolute top-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-white bg-accent shadow-[0_2px_10px_rgba(36,72,196,0.35)]" initial={{
          left: reduced ? '50%' : '12%'
        }} animate={{
          left: reduced ? '50%' : ['12%', '86%', '50%']
        }} transition={reduced ? {
          duration: 0
        } : {
          duration: 0.9,
          times: [0, 0.5, 1],
          ease: EASE,
          delay: 0.15
        }} data-id="element-233" data-mp="23c26hwb661pt" />
        </div>
        <div className="mt-1 grid grid-cols-[1fr_auto_1fr] items-start gap-2 font-mono text-[10px] tracking-[0.1em]" data-id="element-234" data-mp="3jtpu3pss3jjv">
          <span className="text-graphite" data-id="element-235" data-mp="1i1xuv9mo6k65">← TOO LITTLE</span>
          <span className="text-center font-medium text-accent" data-id="element-236" data-mp="1mu7cm2dmsdxc">
            APPROPRIATE
            <br data-id="element-237" data-mp="185kz867kdw8r" />
            RESPONSE
          </span>
          <span className="text-right text-graphite" data-id="element-238" data-mp="182yj3i6ly8ex">TOO MUCH →</span>
        </div>
      </div>

      <dl className="mt-6 border-b border-ink/10" data-id="element-239" data-mp="1d4fl5h0tw0x3">
        {responseOutcomes.map(o => <div key={o.label} className="grid grid-cols-[104px_1fr] gap-3 border-t border-ink/10 py-3" data-id="element-240" data-mp="20ui5tc2ey4lo">
            <dt className={`text-[13px] font-semibold ${o.primary ? 'text-accent' : 'text-ink'}`} data-id="element-241" data-mp="25s1tf2l03tqa">{o.label}</dt>
            <dd className="text-[13px] leading-snug text-graphite" data-id="element-242" data-mp="1qxx0sqqe8thu">{o.text}</dd>
          </div>)}
      </dl>

      <div className="mt-auto pt-6" data-id="element-243" data-mp="fgdugphioaf2">
        <PrimaryButton onClick={onNext} data-id="element-244" data-mp="ffcdk4dtktpf">CONTINUE</PrimaryButton>
      </div>
    </div>;
}